import { type Child } from '../api'
import { theme } from '../theme'
import { Page } from '../components/ui'
import { BuddyMaker } from '../components/BuddyMaker'
import { BackRow } from './MysteryWord'

/**
 * A child builds their own Sprout Buddy, from the "My buddy" button on Home.
 *
 * Behind their PIN like the rest of their own part of the app, and saved as
 * their picture, so it is what they see on their card from then on.
 */
export function BuddyScreen({ child, onHome }: { child: Child; onHome: () => void }) {
  return (
    <Page width={560}>
      <BackRow onBack={onHome} label="← Home" />
      <h1 style={{ margin: '4px 0 2px', fontSize: 28, color: theme.text }}>
        {child.display_name}’s Sprout Buddy
      </h1>
      <p style={{ margin: '0 0 10px', fontSize: 16, color: theme.muted }}>
        Make it yours. Change it any time.
      </p>
      <BuddyMaker child={child} onSaved={onHome} onCancel={onHome} />
    </Page>
  )
}
